export enum ResourceSkill {
  Delivery = "Delivery",
  Merchandise = "Merchandise",
  Order = "Order",
  AutonomousAgent = "AutonomousAgent"
}
